import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div
            data-testid="payment-cancel-page"
            className="min-h-screen bg-carbon grid place-items-center px-6"
        >
            <div className="max-w-lg w-full glass rounded-3xl p-8 md:p-10 text-center shadow-glow-cyan">
                <XCircle size={48} className="text-slate-400 mx-auto" />
                <h1 className="font-display text-3xl text-white mt-6 font-bold">
                    Deposit not completed
                </h1>
                <p className="text-slate-400 mt-3 leading-relaxed">
                    No worries — you haven&rsquo;t been charged. Your quote is
                    still saved and a specialist will be in touch. You can lock
                    in your slot any time.
                </p>
                <Link
                    to="/"
                    data-testid="back-home-link"
                    className="inline-block mt-8 px-6 py-3 text-sm uppercase tracking-[0.15em] font-bold text-white bg-safety hover:bg-safety-dark shadow-glow-orange transition-all rounded-xl"
                >
                    Back to Panel Pros
                </Link>
            </div>
        </div>
    );
}
